import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Grid, Heart, ShoppingCart, User } from 'lucide-react';
import { ShieldCheck, Bell, FileText } from 'lucide-react';
import { useCart, useWishlist, useLanguage } from '../../contexts/SiteContexts';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';

export const BottomNav = () => {
  const { cart, setIsCartOpen } = useCart();
  const { wishlist } = useWishlist();
  const { user } = useAuth();
  const { t } = useLanguage();

  const navItems = [
    { to: "/", icon: <Home size={22} />, label: t('home') },
    { to: "/categories", icon: <Grid size={22} />, label: t('categories') },
    { to: "/doctor-hub", icon: <ShieldCheck size={22} />, label: "Dr to Dr" },
    { to: "/needs", icon: <Bell size={22} />, label: t('needs') },
    { to: "/blogs", icon: <FileText size={22} />, label: t('blog') },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-[100] bg-white/80 backdrop-blur-xl border-t border-slate-100 px-6 pb-8 pt-4 flex items-center justify-between rounded-t-[3rem] shadow-[0_-10px_40px_-15px_rgba(0,0,0,0.1)]">
      {navItems.map((item, idx) => (
        <NavLink
          key={idx}
          to={item.to}
          className={({ isActive }) => cn(
            "flex flex-col items-center space-y-1 transition-all duration-300",
            isActive && item.to !== "#" ? "text-indigo-600 scale-110" : "text-slate-400 hover:text-slate-600"
          )}
        >
          <div className={cn(
            "p-2 rounded-2xl transition-all",
            "active:scale-90"
          )}>
            {item.icon}
          </div>
          <span className="text-[10px] font-black uppercase tracking-widest">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};
